// Environment variable validation utility

export interface EnvironmentConfig {
  openRouterApiKey: string;
  siteUrl: string;
  siteName: string;
  githubToken?: string;
  githubApiUrl?: string;
}

export function validateEnvironment(): EnvironmentConfig {
  const config: EnvironmentConfig = {
    openRouterApiKey: '',
    siteUrl: '',
    siteName: '',
    githubToken: undefined,
    githubApiUrl: undefined
  };

  // Check OpenRouter API Key
  config.openRouterApiKey = process.env.REACT_APP_OPENROUTER_API_KEY || '';
  if (!config.openRouterApiKey) {
    console.error('❌ REACT_APP_OPENROUTER_API_KEY is not set');
    console.error('   Get your API key from: https://openrouter.ai/keys');
    console.error('   Add it to your .env file or environment variables');
  } else {
    console.log('✅ OpenRouter API key is configured');
  }

  // Check optional environment variables
  config.siteUrl = process.env.REACT_APP_SITE_URL || 'https://githubmate.ai/';
  config.siteName = process.env.REACT_APP_SITE_NAME || 'GitHubMate';
  config.githubToken = process.env.REACT_APP_GITHUB_TOKEN;
  config.githubApiUrl = process.env.REACT_APP_GITHUB_API_URL;

  return config;
}

export function isProduction(): boolean {
  return process.env.NODE_ENV === 'production';
}

export function getEnvironmentInfo(): string {
  const env = process.env.NODE_ENV || 'development';
  const hasOpenRouterKey = !!process.env.REACT_APP_OPENROUTER_API_KEY;
  const hasGitHubToken = !!process.env.REACT_APP_GITHUB_TOKEN;
  
  return `Environment: ${env}, OpenRouter: ${hasOpenRouterKey ? '✅' : '❌'}, GitHub: ${hasGitHubToken ? '✅' : '⚠️'}`;
}

export function getMissingEnvironmentVariables(): string[] {
  const missing: string[] = [];
  
  if (!process.env.REACT_APP_OPENROUTER_API_KEY) {
    missing.push('REACT_APP_OPENROUTER_API_KEY');
  }
  
  return missing;
} 